
__webpack_require__.svgSprite = function(id) {
    return "/static/svg/sprite.02ee5f0a.svg#" + id;
};
          